module.exports = __webpack_public_path__ + "media/src/images/profil-dummy-f77216569e0b2e25c9918a9bd9c33dc1.jpg";